import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialyvisit',
  templateUrl: './dialyvisit.component.html',
  styleUrls: ['./dialyvisit.component.css']
})
export class DialyvisitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
